import { HttpClient } from '@/shared/lib/http-client';

export const deleteTask = async (id) => {
  const response = await HttpClient.delete(`/tasks/${id}`);

  return response.data?.data;
};
